/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

/**
 *
 * @class UserCommandMergeResult
 *
 * @brief the model for single (validation) error we get back from merging
 * or validating user commands into scenarios.
 *
 * {
 *    "file": "\/tmp\/commands-6d08be4d-cfbb-42b7-93b0-27f93b70178b.txt",
 *    "line": 1,
 *    "column": 1,
 *    "text": "...",
 *    "message": "...",
 *    "markup": "..."
 * }
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2023
 *
 */
export class UserCommandError {

  public file:    string = '';
  public line:    number =  1;
  public column:  number =  1;
  public text:    string = '';
  public message: string = '';
  public markup:  string = '';

  /** standard constructor, allow for partial data to be given */
  public constructor(init?: Partial<UserCommandError>) {

    Object.assign(this, init);
  }

  public to_json(): any {

    return {
     file:    this.file,
     line:    this.line,
     column:  this.column,
     text:    this.text,
     message: this.message,
     markup:  this.markup
    };
  }
}
